import {
  Component,
  Input,
  OnInit
} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UserService} from '../service/user.service';
// modal content components
import {CreateUserComponent} from './create-user/create-user.component';
import {CreateApiKeyComponent} from './create-api-key/create-api-key.component';
import {OrganisationFormComponent} from './organisation-form/organisation-form.component';
import {PopupsComponent} from './popups/popups.component';
import {UpdatePasswordComponent} from './update-password/update-password.component';
import {OrganizationService} from '../service/organization.service';
import {MessagingService} from '../service/messaging.service';
import {UpdateMyAccountComponent} from './update-my-account/update-my-account.component';


@Component({
  selector: 'modal-edit',
  styleUrls: ['./modal-edit.component.scss'],
  templateUrl: './modal-edit.component.html'
})

export class UserEditModalComponent implements OnInit {
  public currentUser;

  @Input() formType: string;
  @Input() updateUser: Object;
  @Input() updateUserName: string;
  @Input() tabIndex: string;

  constructor(public userService: UserService,
              private modalService: NgbModal,
              private orgService: OrganizationService,
              private msgService: MessagingService) {


    this.currentUser = this.userService.currentUserSubject.getValue();
  }

  ngOnInit() {
  }

  open(type, user): void {
    let modalRef;
    switch (type) {
      case 'Update':
        this.userService.setUpdatableUser(user);
        this.msgService.setModalTitle('Update user: ' + user.name);
        modalRef = this.modalService.open(CreateUserComponent, {backdrop: 'static'});
        break;
      case 'Add new user':
        this.msgService.setModalTitle('Create new user');
        modalRef = this.modalService.open(CreateUserComponent, {backdrop: 'static'});
        break;
      case 'My account':
        this.userService.setUpdatableUser(this.currentUser);
        this.msgService.setModalTitle('Edit ' + this.currentUser.name);
        modalRef = this.modalService.open(UpdateMyAccountComponent, {backdrop: 'static'});
        break;
      case 'Create API User':
        this.userService.setUpdatableUser(user);
        this.msgService.setModalTitle('Create API User');
        modalRef = this.modalService.open(CreateApiKeyComponent, {backdrop: 'static'});
        break;
      case 'Create Organisation':
        this.orgService.setUpdatableOrg(null);
        this.msgService.setModalTitle('Create organisation');
        modalRef = this.modalService.open(OrganisationFormComponent, {backdrop: 'static'});
        break;
      case 'Update Organisation':
        this.orgService.setUpdatableOrg(user);  // setUpdatableOrg(org)
        this.msgService.setModalTitle('Update organisation: ' + user.title);
        modalRef = this.modalService.open(OrganisationFormComponent, {backdrop: 'static'});
        break;
      case 'Update API user':
        this.userService.setUpdatableUser(user);
        this.msgService.setModalTitle('Update API user: ' + user.name);
        modalRef = this.modalService.open(CreateApiKeyComponent, {backdrop: 'static'});
        break;
      case 'Regenerate Key':
        this.msgService.setModalTitle('Regenerate Key');
        modalRef = this.modalService.open(PopupsComponent, {backdrop: 'static'});
        break;
      case 'Update Password':
        this.msgService.setModalTitle('Update Password');
        modalRef = this.modalService.open(UpdatePasswordComponent, {backdrop: 'static'});
        break;
      default:
        break;
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/modal-edit/modal-edit.component.ts